module.exports = __webpack_public_path__ + "img/spinner_purple.e2eb9df3.svg";